import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const readonlyPostalCodeFieldStyle = css`
  background-color: ${theme.colors.neutral5};
  margin-bottom: ${theme.spacing(2)};
  border: none;

  input:disabled {
    color: ${theme.font.colors.default};
  }

  label {
    color: ${theme.font.colors.subdued};
  }
`;
